import { localCliComponentUpdateProjectionSchema, localServiceComponentUpdateProjectionSchema } from "../local-components.js";
import * as z$1 from "zod/v4";
//#region src/schemas/cli/daemon-status-server-requirement.ts
const cliVersionVerdictKindSchema = z$1.enum([
	"aligned",
	"channel_behind",
	"channel_ahead",
	"channel_unavailable",
	"server_unavailable"
]);
const serviceVersionVerdictKindSchema = z$1.enum([
	"aligned",
	"update_available",
	"update_required",
	"unknown",
	"server_unavailable"
]);
const cliVersionVerdictSchema = z$1.strictObject({
	kind: cliVersionVerdictKindSchema,
	message: z$1.string().trim().min(1)
});
const serviceVersionVerdictSchema = z$1.strictObject({
	kind: serviceVersionVerdictKindSchema,
	message: z$1.string().trim().min(1)
});
const daemonStatusServerRequirementUnavailableReasonSchema = z$1.enum([
	"signed_out",
	"offline",
	"request_failed"
]);
const availableDaemonStatusServerRequirementSchema = z$1.strictObject({
	available: z$1.literal(true),
	generatedAt: z$1.iso.datetime({ offset: true }),
	cli: localCliComponentUpdateProjectionSchema,
	service: localServiceComponentUpdateProjectionSchema,
	verdict: z$1.strictObject({
		cli: cliVersionVerdictSchema,
		service: serviceVersionVerdictSchema
	})
});
const unavailableDaemonStatusServerRequirementSchema = z$1.strictObject({
	available: z$1.literal(false),
	reason: daemonStatusServerRequirementUnavailableReasonSchema,
	detail: z$1.string().nullable()
});
const daemonStatusServerRequirementSchema = z$1.discriminatedUnion("available", [availableDaemonStatusServerRequirementSchema, unavailableDaemonStatusServerRequirementSchema]);
//#endregion
export { cliVersionVerdictKindSchema, cliVersionVerdictSchema, daemonStatusServerRequirementSchema, daemonStatusServerRequirementUnavailableReasonSchema, serviceVersionVerdictKindSchema, serviceVersionVerdictSchema };

//# sourceMappingURL=daemon-status-server-requirement.js.map